export type Padding = {top: number; bottom: number; left: number; right: number;};
export type RowDirection = 'row' | 'column';
export type JustifyContent = 'start' | 'end' | 'center';
export type AlignItems = 'start' | 'end' | 'center';
